import React, { Fragment } from "react";

const SourcesPdc = ({ sources = [] }) => {
  return (
    <Fragment>
      <div className="p-pdc-detail-sources-title">Sources</div>
      <div className="p-flex-col">
        {sources.map((source, i) => (
          <div key={i}>
            <b>{source.nom}</b>
            <span>{` : ${source.valeur || "non renseigné"}`}</span>
            <br />
            <br />
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default SourcesPdc;



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/Sources.detailpdc.js